module.exports = __webpack_public_path__ + "images/emoji/doughnut.ba4c3b68395faf376d49.png";